import { LayoutGrid } from "lucide-react";

const FrameworksTab = ({ frameworksData }) => {

    return (<>
        <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
            <div>
                <h3 className="text-2xl font-bold text-slate-900 tracking-tight">Active Frameworks</h3>
                <p className="text-sm text-slate-500 mt-1">Regulatory and security standards applied to your scope.</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {frameworksData.map((fw) => (
                <div key={fw.id} className="bg-white rounded-2xl ring-1 ring-slate-200/60 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 overflow-hidden flex flex-col group">
                    <div className={`h-1.5 w-full bg-${fw.color}-500`}></div>
                    <div className="p-6 flex-1 flex flex-col">
                        <div className="flex justify-between items-start mb-5">
                            <div className="bg-slate-50 p-3 rounded-2xl ring-1 ring-slate-100 group-hover:bg-white transition-colors">
                                <LayoutGrid size={24} className={`text-${fw.color}-600`} />
                            </div>
                            <span className={`text-xs font-bold px-3 py-1.5 rounded-full bg-${fw.color}-50 text-${fw.color}-700 ring-1 ring-${fw.color}-200/50`}>
                                {fw.controls} Controls
                            </span>
                        </div>
                        <h4 className="text-xl font-bold text-slate-900 mb-1">{fw.name}</h4>
                        <p className="text-sm font-medium text-slate-500 mb-6">{fw.description}</p>
                        
                        <div className="mt-auto pt-4 border-t border-slate-100">
                            <p className="text-xs text-slate-500 flex items-center gap-2">
                                <span className="font-bold uppercase tracking-widest text-[10px] text-slate-400">Trigger:</span>
                                <span className="font-semibold text-slate-700">{fw.reason}</span>
                            </p>
                        </div>
                    </div>
                </div>
            ))}
            </div>
        </div>
    </>);
};

export default FrameworksTab;